import { Member } from 'api/MembersAPI';
import { User } from 'modules/graphql';
import { CombinedRole } from 'modules/roles/types';
import { LastModifiedCell } from 'ui/indexPages/tables/cells/LastModifiedCell';

export type LastModifiedCellProps = {
  getMemberByUserId: (userId: string) => Member | undefined;
  getUserById: (id: string) => User | undefined;
  role: CombinedRole;
};

export const LastModifiedTableCell = ({
  getMemberByUserId,
  getUserById,
  role,
}: LastModifiedCellProps) => {
  const createdByMember = getMemberByUserId(role.createdBy);
  const modifiedByMember =
    role.createdBy === role.updatedBy ? createdByMember : getMemberByUserId(role.updatedBy);
  const modifiedByUser = getUserById(role.updatedBy);

  const createdBy = {
    emailAddress: `${createdByMember?.email}`,
    fullName: `${createdByMember?.firstName} ${createdByMember?.lastName}`,
  };

  const modifiedBy = {
    emailAddress: `${modifiedByMember?.email}`,
    fullName: `${modifiedByMember?.firstName} ${modifiedByMember?.lastName}`,
    avatarUrl: modifiedByUser?.avatarUrl,
  };

  return (
    <LastModifiedCell
      createdAt={role.createdAt}
      createdBy={createdBy}
      modifiedAt={role.updatedAt}
      modifiedBy={modifiedBy}
      showAvatar
    />
  );
};
